//课程直播列表功能
import request from './request'

//获取课程嘉宾列表
export function _guestsList(data = {}) {
    const config = Object.assign(data, {
      method: 'get',
      url: '/admin/course/guests',
    })
    return request(config)
  }

//提交添加嘉宾
export function _guestAdd(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/guest/add',
  })
  return request(config)
}


//添加用户为嘉宾

